import { render, staticRenderFns } from "./Builds.vue?vue&type=template&id=c927604c&scoped=true&"
import script from "./Builds.vue?vue&type=script&lang=js&"
export * from "./Builds.vue?vue&type=script&lang=js&"
import style0 from "./Builds.vue?vue&type=style&index=0&id=c927604c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c927604c",
  null
  
)

export default component.exports